import { GetURLParameter } from "./helpers";
import "./cart_summary_helpers";
import "./subscribe-and-save";
import "./subscribe-and-save-settings";
import ClipboardJS from "clipboard";
import redirectWarnings from "./redirectWarnings";

(function detectDeviceType() {
    var isTouchDevice =
        /Windows Phone/.test(navigator.userAgent) ||
        "ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch);
    var documentClass = isTouchDevice ? "touchdevice" : "desktopdevice";
    document.documentElement.className += " " + documentClass;
})();

jQuery(function () {
    initImageFallback();
    initBrokenImageHiding();
    initAddRemoveRow();
    initDarwinPopups();
    initDarwinAutocomplete();
    initDarwinMobileNav();
    initDarwinCustomForms();
    initStepsValidation();
    initSteps();
    initTabs();
    initOpenClose();
    initReveals();
    initFixedTabs();
    initLoadMore();
    initAddClasses();
    initDarwinFormValidation();
    initClearInputField();
    initCopyToClipboard();
    initSelect();
    initContext();

    // Bad, but fast
    if (jQuery(".detail-map__geo-sources--js").length) {
        initMapBox();
    }

    redirectWarnings();
});

/**
 * Take maps on detail page and load non-interactive mapbox
 */
function initMapBox() {
    // If you want to resize a map, you need a reference to the map, so let's push them onto an array for later handling
    window.mapboxmaps = [];

    if (
        typeof MapboxGeocoder !== "undefined" &&
        typeof mapboxgl !== "undefined" &&
        mapboxgl.supported()
    ) {
        var $mapJSON = jQuery(".detail-map__geo-sources--js");
        var accessToken =
            "pk.eyJ1Ijoid3JzdHVkaW9zIiwiYSI6ImNrcG12a25lZDFybTAyb3JyaDVkd2plaWoifQ.OQTVR03yOqWJN_cbiA8wfw";
        let element = $mapJSON;

        if (jQuery(element).length) {
            var geoSources = JSON.parse(element.html());

            if (geoSources) {
                mapboxgl.accessToken = accessToken;

                let geocoderDOMElement = jQuery(element)
                    .closest(".detail-map--js")
                    .find(".detail-map-target--js")
                    .get(0);

                var map = new mapboxgl.Map({
                    container: geocoderDOMElement,
                    style: "mapbox://styles/mapbox/streets-v11",
                    center: [geoSources[0].longitude, geoSources[0].latitude],
                    zoom: 9,
                    interactive: false,
                });

                let locations = [];
                for (let i = 0; i < geoSources.length; i++) {
                    addMapMarker(
                        map,
                        geoSources[i].latitude,
                        geoSources[i].longitude
                    );

                    // LAT LNG OBJECTS IN MAPBOX ARE LONGITUDE FIRST, THEN LATITUDE.
                    locations.push([
                        geoSources[i].longitude,
                        geoSources[i].latitude,
                    ]);
                }

                if (geoSources.length > 1) {
                    let bounds = locations.reduce(function (bounds, coord) {
                        return bounds.extend(coord);
                    }, new mapboxgl.LngLatBounds(locations[0], locations[0]));

                    map.fitBounds(bounds, {
                        padding: 70,
                        duration: 0,
                    });
                }

                window.mapboxmaps.push(map);
            }
        }
    } else {
        console.warn("mapbox was not defined!");
    }
}

/**
 * Add marker to map
 * @param map
 * @param lat
 * @param lng
 */
function addMapMarker(map, lat, lng) {
    // create a HTML element for each feature
    let el = document.createElement("div");
    el.className = "marker";

    // make a marker for each feature and add to the map
    new mapboxgl.Marker(el).setLngLat([lng, lat]).addTo(map);
}

function initImageFallback() {
    var switchToFallback = function () {
        var fallbackSource = $(this).data("fallback-src");

        // fallbackSources occur on the ED agent roster pages
        if (fallbackSource) {
            $(this).attr("src", fallbackSource);
            if ($(this).hasClass("enterprise-dash__campaign")) {
                $(this).addClass("enterprise-dash__campaign-missing-photo");
            }
        }
    };

    var imagesWithFallback = $("img[data-fallback-src]");

    // Switch to fallback for images that will fail in future
    imagesWithFallback.error(switchToFallback);

    // Switch to fallback for images that have already failed to load
    imagesWithFallback.each(function (i, img) {
        if (img.complete && img.naturalWidth === 0) {
            switchToFallback.call(img);
        }
    });
}

function initBrokenImageHiding() {
    var hideBrokenImagesHandler = function () {
        $(this).hide();
    };

    var imagesThatMayNeedToBeHidden = $("img.hide-image-on-error--js");

    // Handle hiding images that will fail in future
    imagesThatMayNeedToBeHidden.error(hideBrokenImagesHandler);

    // Hide images that have already failed to load
    imagesThatMayNeedToBeHidden.each(function (i, img) {
        if (img.complete && img.naturalWidth === 0) {
            hideBrokenImagesHandler.call(img);
        }
    });
}

function initContext() {
    var body = $("body");
    var currentContext = body.data("current-context");
    var selectedAgent = body.data("viewing-as-agent-id");
    var previousAgent = body.data("last-viewed-agent-id");
    var selectedOffice = body.data("viewing-as-office-id");
    var selectedBroker = body.data("viewing-as-broker-id");
    var searchParams = {};

    function refreshSearchParams() {
        searchParams.current_context = currentContext || null;
        searchParams.viewing_as_agent_id = selectedAgent || null;
        searchParams.last_viewed_agent_id =
            previousAgent || selectedAgent || null;
        searchParams.viewing_as_office_id = selectedOffice || null;
        searchParams.viewing_as_broker_id = selectedBroker || null;
    }

    function mapSearchParams(searchParams) {
        return Object.keys(searchParams)
            .map(function (key, index) {
                if (searchParams[key]) {
                    return key + "=" + searchParams[key];
                } else {
                    return null; //Don't insert key into string for empty values
                }
            })
            .filter(function (item) {
                return item !== null; //Remove empty values from array
            })
            .join("&");
    }

    refreshSearchParams();

    body.on("context_changed", function (srcElement, arg) {
        currentContext = arg.selected_context;
        selectedAgent = arg.selected_agent;
        selectedOffice = arg.selected_office;
        selectedBroker = arg.selected_broker;
        previousAgent = arg.last_viewed_agent;

        refreshSearchParams();

        $(".data-context-link").each(function () {
            var link = $(this).attr("href");
            var search = this.search;

            var contextLink = link.replace(
                search,
                "?" + mapSearchParams(searchParams)
            );

            $(this).attr("href", contextLink);
        });

        setTimeout(function () {
            Intercooler.refresh("/context");
        }, 0);
    });

    $(document).on("beforeAjaxSend.ic", function (event, req, elt) {
        if (searchParams) {
            if (req.data) {
                req.data += "&" + mapSearchParams(searchParams);
            } else {
                req.data = mapSearchParams(searchParams);
            }
        }
    });

    body.on("complete.ic", function () {
        setTimeout(initImageFallback, 0);
        setTimeout(initTabs, 0);
    });

    var icErrorHandler = function (event, elt, status, str, xhr, details) {
        console.log("HomeSpotter error detected: ");

        var errElements = $($.parseHTML(details));
        var errorResponseText = errElements.not("style").text();
        var errorHtml = $(
            "<div style='background-color: #ffcccc; padding: 15px;'/>"
        )
            .append("<div>Error: " + status + ": " + str + "</div>")
            .append(errElements);
        console.error(errorResponseText);
        $("#header").prepend(errorHtml);
    };

    $(document).on("error.ic", function (event, elt, status, str, xhr) {
        if (str === "Unauthorized") {
            //TODO handle unauthorized responses gracefully (maybe a message asking them to sign in again, with a link to the sign in page?)
            icErrorHandler(event, elt, status, str, xhr, xhr.responseText);
        } else if (status === "timeout") {
            //TODO handle timeout gracefully (maybe a nice message to the user asking them to wait a bit and then try again?
            icErrorHandler(event, elt, status, str, xhr, xhr.responseText);
        } else if (status === "abort") {
            //don't worry about aborted requests
        } else {
            if (xhr.status == 0 && status === "error") {
                //TODO we couldn't reach the server at all for some reason
                //  maybe the server is down
                //  maybe the user has no network connection
            } else {
                //totally unexpected error ... likely a code problem
                icErrorHandler(event, elt, status, str, xhr, xhr.responseText);
            }
        }
    });

    $(document).on(
        "success.ic",
        function (event, elt, data, textStatus, xhr, requestId) {
            if (data.indexOf("xdebug-error") >= 0) {
                $(elt).trigger("error.ic", [
                    elt,
                    "error",
                    textStatus,
                    xhr,
                    data,
                ]);
            }
        }
    );

    //if we have any intercooler "ic-ignore" elements, let's _not_ let the JCF library customize those controls just yet, we will do that after
    // intercooler has processed and cloned the nodes, so that all the right event handlers get attached to the intercooler-added elements
    $(".ic-ignore").each(function () {
        jcf.destroyAll($(this));
    });

    // anytime we manipulate the DOM via intercooler, ask JCF to initialize any form controls that we might have added/changed
    Intercooler.ready(function (elt) {
        jcf.replaceAll($(elt));
    });
}

// popups init
function initDarwinPopups() {}

// init copy to clipboard
function initCopyToClipboard() {
    var isIos =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var clipboard = new ClipboardJS(".js-copy");

    if (isIos) {
        jQuery("body").addClass("no-copy-link");
    }
}

// init add remove row
function initAddRemoveRow() {
    jQuery(".js-add-holder").each(function () {
        var holder = jQuery(this);
        var rowContainer = holder.find(".rows-container");
        var existingRowsContainer = holder.find(".existing-rows-container");
        var addButtonContainer = holder.find(".btn-row");
        var row = rowContainer.find(".js-row.row-default");
        var template = row.clone();
        var btnAdd = addButtonContainer.find(".js-add");
        var rowLast;
        var rowPrev;

        btnAdd.on("click", function (e) {
            e.preventDefault();
            template.show();
            addRow(existingRowsContainer, template);
            setHolderClass();
            jcf.replaceAll();
        });

        holder.on("click", ".js-remove", function (e) {
            e.preventDefault();
            removeRow(jQuery(e.currentTarget));
            setHolderClass();
        });

        function addRow(holder, row) {
            rowLast = row.clone().appendTo(holder);
            rowPrev = rowLast.prev().addClass("disabled");
            disabledState(rowPrev);
        }

        function removeRow(btn) {
            btn.closest(".js-row").remove();
        }

        function disabledState(row) {
            if (row.length) {
                row.find("input, select, textarea").each(function () {
                    jQuery(this).attr("disabled", "disabled");
                });
            }
        }

        function setHolderClass() {
            if (holder.has(".js-row.disabled").length) {
                holder.addClass("inc-delete");
            } else {
                holder.removeClass("inc-delete");
            }
        }
    });
}

$(document).on("click", "a.btn-delete-mls-agent-id", function () {
    const deleteButton = $(this);
    const clicked = deleteButton.attr("data-clicked");
    if (clicked === "0" || clicked === undefined) {
        deleteButton.attr("data-clicked", "1");
        const container = deleteButton.closest(".rows-container");
        const mlsId = container.find("input[name='keep-mls-id[]']").val();
        const mlsAgentId = container
            .find("input[name='keep-mls-agent-id[]']")
            .val();
        $.ajax({
            url: deleteButton.data("shortCode"),
            method: "POST",
            data: {
                mls_id: mlsId,
                mls_agent_id: mlsAgentId,
                agent_id: deleteButton.data("agentId"),
                type: "manageListingsAffected",
                subtype: "removal",
            },
            success: function (response) {
                deleteButton.attr("data-clicked", "0");
                const style = (color, backgroundColor, borderColor) => ({
                    textAlign: "center",
                    fontSize: "10px",
                    padding: "0.75rem 1.25rem",
                    marginBottom: "1rem",
                    border: "1px solid transparent",
                    borderRadius: "0.25rem",
                    color,
                    backgroundColor,
                    borderColor,
                });
                const feedback = $(deleteButton)
                    .closest(".feedback-container")
                    .find(".feedback-wrap .feedback-row");
                feedback
                    .html(response.result.text)
                    .css(style("#fff", "#dc3545", "#dc3545"))
                    .show();

                container.remove();
            },
            error: function (xhr, status, error) {
                console.error(xhr.responseText);
            },
            complete: function () {
                deleteButton.attr("data-clicked", "0");
            },
        });
    }
});

$(document).on("click", "a.btn-add-mls-agent-id", function () {
    const isFirstClick = !$(this).data("used");
    $(this).data("used", true);
    setTimeout(() => {
        $(".form-row-template").each(function () {
            const elements = $(this).find(
                isFirstClick
                    ? ".jcf-select.jcf-unselectable.jcf-select-admin"
                    : ".template-unique"
            );
            if (elements.length > 0) {
                const $element = elements.first();
                $element
                    .removeClass("jcf-select jcf-unselectable jcf-select-admin")
                    .addClass("template-unique");
                $element
                    .find(".jcf-select-text:eq(1)")
                    .text("")
                    .end()
                    .find(".jcf-select")
                    .css("width", "100%");
            }
        });
    }, 0);
});

$(document).on("blur", "input[name='mls-agent-id[]']", function () {
    const inputElement = this;
    const inputVal = $(inputElement).val().trim();
    $(inputElement).val(inputVal);

    const feedback = $(inputElement)
        .closest(".feedback-container")
        .find(".feedback-wrap .feedback-row");
    if (inputVal.length > 0) {
        const style = (color, backgroundColor, borderColor) => ({
            textAlign: "center",
            fontSize: "10px",
            padding: "0.75rem 1.25rem",
            marginBottom: "1rem",
            border: "1px solid transparent",
            borderRadius: "0.25rem",
            color,
            backgroundColor,
            borderColor,
        });
        const shortCode = $(inputElement)
            .closest(".row-wrap")
            .find("select")
            .data("shortCode");
        const agentId = $(inputElement)
            .closest(".row-wrap")
            .find("select")
            .data("agentId");
        $.post(shortCode, {
            mls_id: $(inputElement).closest(".row-wrap").find("select").val(),
            mls_agent_id: inputVal,
            agent_id: agentId,
            type: "manageListingsAffected",
        })
            .done((response) => {
                feedback
                    .html(response.result.text)
                    .css(style(...response.result.style))
                    .show();
            })
            .fail((xhr) => {
                feedback
                    .html(JSON.parse(xhr.responseText).result.error)
                    .css(style(...JSON.parse(xhr.responseText).result.style))
                    .show();
            });
    } else {
        feedback.hide();
    }
});

// init clear input fields
function initClearInputField() {
    jQuery(".js-search-clear").each(function () {
        var holder = jQuery(this);
        var btnClear = holder.find(".js-clear");
        var activeClass = "search-focused";
        var inputField = holder.find(".js-field");

        if (inputField.val().length) {
            holder.addClass(activeClass);
        }

        inputField.on("keyup blur change", function () {
            if (inputField.val().length) {
                holder.addClass(activeClass);
            }
        });

        if (btnClear.length) {
            btnClear.on("click", function () {
                inputField.val("");
                inputField.keyup.apply(inputField);
                holder.removeClass(activeClass);
            });
        }
    });
}

function initDarwinAutocomplete() {
    jQuery("[data-autocomplete]").uiAutocomplete({
        open: function (event, ui) {
            jQuery(".ui-autocomplete").off(
                "menufocus hover mouseover mouseenter"
            );
        },
    });
}

// add class on click
function initAddClasses() {
    lib.each(lib.queryElementsBySelector(".toggle"), function (index, item) {
        new AddClass({
            item: item,
            classAdd: "toggle-active",
        });
    });
}

// init steps
function initSteps() {
    var stepInitClass = "js-step-inited";
    var stepActiveClass = "js-step-active";
    var ignoreClass = "ignore";

    jQuery(".js-steps-form").each(function () {
        var form = jQuery(this);
        var steps = form.find(".js-step");
        var lastStep = form.find(".js-step-last");

        form.on("submit", function (e) {
            e.preventDefault();
            steps.filter("." + stepActiveClass).trigger("validate-step");
        });
        initStep(steps.eq(0));
        showStep(steps.eq(0), true);

        function initStep(step) {
            if (step.hasClass(stepInitClass)) {
                showStep(step);
                return;
            }

            var btnNext = step.find(".btn-next");

            step.on("validate-success", function () {
                if (step.data("nextStep")) {
                    showNextStep(step);
                } else {
                    onAllCompleted();
                }
            }).on("validate-error", function () {});

            btnNext.on("click", nextClickHandler);
            step.addClass(stepInitClass);

            function nextClickHandler() {
                step.trigger("validate-step");
            }
        }

        function goToStep(step) {
            var currStep = steps.filter("." + stepActiveClass);
            var nextStep = step;

            hideStep(currStep);
            initStep(nextStep);
            showStep(nextStep);
        }

        function showNextStep(step) {
            step = step || steps.filter("." + stepActiveClass);
            var nextStep = jQuery(step.data("nextStep"));

            hideStep(step);
            initStep(nextStep);
            showStep(nextStep);
        }

        function onAllCompleted() {
            steps.removeClass(stepActiveClass);
            form.addClass("form-completed");

            jQuery.ajax({
                url: form.attr("action") || "/",
                type: form.attr("method") || "GET",
                data: form.serialize(),
            });
        }

        function showStep(step, initial) {
            step.addClass(stepActiveClass);
            steps.addClass(ignoreClass);
            step.removeClass(ignoreClass);
        }

        function hideStep(step) {
            step.removeClass(stepActiveClass);
        }
    });
}

// validation init
function initStepsValidation() {
    jQuery(".js-steps-form .js-step").darwinFormValidation({
        errorClass: "input-error",
        successClass: "success",
        inputs: "input, textarea, select, .radio-group-required",
        errorHolder: ".validation-class-holder",
        ignoreClass: "ignore",
        validationRules: {
            ".radio-group-required": {
                isError: function (currentObject) {
                    return !currentObject.find("input:radio:checked").length;
                },
            },
        },
        onInit: function (self) {
            this.form.on("validate-step", this.onSubmitHandler);
        },
        onSubmit: function (self) {
            if (self.successFlag) {
                self.form.trigger("validate-success");
            } else {
                self.form.trigger("validate-error");
            }
        },
    });
}

// mobile menu init
function initDarwinMobileNav() {
    jQuery("body").mobileNav({
        hideOnClickOutside: true,
        menuActiveClass: "nav-active",
        menuOpener: ".nav-opener",
        menuDrop: ".nav-drop",
    });
    jQuery("body").mobileNav({
        hideOnClickOutside: true,
        menuActiveClass: "nav-active",
        menuOpener: ".admin-nav-opener",
        menuDrop: ".admin-nav-drop",
    });
    jQuery(".profile-holder").mobileNav({
        hideOnClickOutside: true,
        menuActiveClass: "profile-active",
        menuOpener: ".profile",
        menuDrop: ".profile-options",
    });
    jQuery(".profile-info").mobileNav({
        hideOnClickOutside: true,
        menuActiveClass: "info-active",
        menuOpener: ".admin-profile",
        menuDrop: ".profile-content",
    });
    jQuery(".dashboard-header").mobileNav({
        menuActiveClass: "search-active",
        menuOpener: ".search-opener",
    });
}

// load more init
function initLoadMore() {
    jQuery(".load-more-holder")
        .loadMore({
            newContentTarget: ".activity-frame",
            linkSelector: "a.load-more",
        })
        .on("ContentLoader/loaded", function (e) {
            var loadHolder = jQuery(this);
            var scrollBlock = loadHolder.find(".jcf-scrollable");
            var jcfAPI = window.jcf && jcf.getInstance(scrollBlock);
            if (loadHolder.find(".btn-holder").length) {
                loadHolder.find(".btn-holder").appendTo(loadHolder);
            }
            if (jcfAPI) jcfAPI.refresh();
        });
}

// init fixed tabs
function initFixedTabs() {
    var win = jQuery(window);
    var fixedClass = "fixed-position";
    var winHeight;
    var endPoint;

    jQuery(".js-fixed-holder").each(function () {
        var holder = jQuery(this);
        var block = holder.find(".js-fixed-block");
        var scrollArea = jQuery("#" + block.data("scrollArea"));
        var helperBlock = jQuery('<div class="js-helper"></div>');
        var blockTop;
        var endPoint;

        helperBlock.appendTo(holder).css({
            height: block.outerHeight() + "px",
        });

        resizeHandler();

        win.on("resize orientationchange", resizeHandler);
        win.on("scroll", scrollHandler);

        function scrollHandler() {
            var winTop = win.scrollTop();
            if (blockTop < winTop && winTop < endPoint) {
                block.addClass(fixedClass);
            } else {
                block.removeClass(fixedClass);
            }
            setTimeout(function () {
                endPoint = scrollArea.offset().top + scrollArea.outerHeight();
            }, 100);
        }

        function resizeHandler() {
            var blockHeight = block.outerHeight();
            winHeight = win.height();
            blockTop = block.offset().top;
            endPoint = scrollArea.offset().top + scrollArea.outerHeight();

            helperBlock.css({
                height: blockHeight + "px",
            });

            scrollHandler();
        }
    });
}

function hideWarningBanner() {
    jQuery(".warning-banner").slideUp(400);
}

// content tabs init
function initTabs() {
    var win = jQuery(window);
    var body = jQuery("html, body");

    jQuery(".tabset").tabset({
        tabLinks: "a",
        autoHeight: true,
        addToParent: true,
        defaultTab: true,
        onChange: function (self) {
            var winTop = win.scrollTop();
            var holderTop = self.$tabHolder.offset().top;
            if (holderTop - self.$holder.outerHeight() < winTop) {
                body.animate(
                    {
                        scrollTop: holderTop - self.$holder.outerHeight(),
                    },
                    500
                );
            }
        },
    });

    if (GetURLParameter("current_tab") === "boostDetailEngagement") {
        $("#boostDetailEngagedTabLink").click();
    }

    // jQuery('.admin-tabset').tabset({
    // 	tabLinks: 'a',
    // 	autoHeight: true,
    // 	addToParent: true,
    // 	defaultTab: false,
    // 	onChange: function(self) {
    // 		var winTop = win.scrollTop();
    // 		var holderTop = self.$tabHolder.offset().top;
    // 		if (holderTop - self.$holder.outerHeight() < winTop) {
    // 			body.animate({
    // 				scrollTop: holderTop - self.$holder.outerHeight()
    // 			}, 500);
    // 		}
    // 	}
    // });
}

// open-close init
function initOpenClose() {
    jQuery(".open-close").openClose({
        activeClass: "active",
        opener: ".opener",
        slider: ".slide",
        animSpeed: 400,
        effect: "slide",
    });
    jQuery(".profile-info").openClose({
        activeClass: "active",
        opener: ".admin-opener",
        slider: ".admin-slide",
        animSpeed: 400,
        effect: "slide",
        hideOnClickOutside: true,
    });
}

// Sets up a listener on a radio button so when it's selected, some other content is revealed
// and hidden when the radio button is deselected
function initReveals() {
    $("[type=radio][data-reveals]").each(function (i, el) {
        var radioName = el.name;
        $("input[name='" + radioName + "']").on("change", function () {
            if ($(el).is(":checked")) {
                $($(el).data("reveals")).show();
            } else {
                $($(el).data("reveals")).hide();
            }
        });
    });
}

// initialize custom form elements
function initDarwinCustomForms() {
    // detect device type
    var isTouchDevice =
        /Windows Phone/.test(navigator.userAgent) ||
        "ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch);
    jcf.replaceAll();

    var scrollBlock = jQuery(".jcf-scrollable");
    var jcfApi = jcf.getInstance(scrollBlock);

    if (isTouchDevice) {
        setTimeout(function () {
            if (jcfApi) jcfApi.destroy();
        }, 100);
    }
}

// initialize custom select for pagination
function initSelect() {
    jcf.setOptions("Select", {
        wrapNative: false,
        wrapNativeOnMobile: false,
    });
    jcf.replaceAll(".custom-drop");
}

function initDarwinFormValidation() {
    jQuery(".form-validation").darwinFormValidation({
        errorClass: "input-error",
        inputs: "input, textarea, select",
        errorHolder: ".form-row",
    });
}

function initIntercomWithUser(
    appId,
    userId,
    userEmail,
    userFullName,
    userHash
) {
    if (userId && 0 !== userId.length) {
        var APP_ID = appId;

        (function () {
            var w = window;
            var ic = w.Intercom;
            if (typeof ic === "function") {
                ic("reattach_activator");
            } else {
                var d = document;
                var i = function () {
                    i.c(arguments);
                };
                i.q = [];
                i.c = function (args) {
                    i.q.push(args);
                };
                w.Intercom = i;
                function l() {
                    var s = d.createElement("script");
                    s.type = "text/javascript";
                    s.async = true;
                    s.src = "https://widget.intercom.io/widget/" + APP_ID;
                    var x = d.getElementsByTagName("script")[0];
                    x.parentNode.insertBefore(s, x);
                }
                if (w.attachEvent) {
                    w.attachEvent("onload", l);
                } else {
                    w.addEventListener("load", l, false);
                }
            }
        })();

        window.Intercom("boot", {
            app_id: APP_ID,
            user_id: userId,
            email: userEmail,
            name: userFullName,
            user_hash: userHash,
        });
    } else {
        console.error("Unable to initialize Intercom without valid user id.");
    }
}
